// The app's loader, over the real maps API. Pages and the hook use this one so the cache is shared.
import { mapsApi } from '../../services/mapsApi';
import { createAreaShapeLoader } from './loader';

// Called through `mapsApi` at request time, so a test that replaces the service is honoured.
export const areaShapeLoader = createAreaShapeLoader({
  getGeosByIds: (type, ids, country, catalogue) => mapsApi.getGeosByIds(type, ids, country, catalogue),
});
